import * as React from "react";
import * as Immutable from "immutable";
import compact from "lodash/compact";
import { useEffect, useState } from "react";
import styled from "styled-components";
import AuthzRolesDomain from "domainActions/roles/AuthzRolesDomain";
import { Button } from "components/bootstrap";
import { Select, Spinner, ErrorAlert } from "components/common";
const SubmitButton = styled(Button)`
  margin-left: 15px;
`;
const FormElements = styled.div`
  display: flex;
`;
const RoleSelectOption = styled.div`
  display: flex;
  align-items: center;
`;
const StyledSelect = styled(Select)`
  flex: 1;
`;
const _renderRoleOption = ({ label }) => /* @__PURE__ */ React.createElement(RoleSelectOption, null, label);
const _options = (roles, assignedRolesIds, identifier) => roles.filter((role) => !assignedRolesIds.includes(identifier(role))).toArray().map((r) => ({ label: r.name, value: r.name, role: r }));
const _assignRole = (selectedRoleNames, roles, onSubmit, setselectedRoleNames, setIsSubmitting, setError) => {
  if (!selectedRoleNames) {
    return;
  }
  const selectedRoleNameList = selectedRoleNames.split(",");
  const selectedRoles = Immutable.Set(
    compact(selectedRoleNameList.map((selection) => roles.find((r) => r.name === selection)))
  );
  if (selectedRoles.size <= 0) {
    setError(`Role assignment failed, because the roles ${selectedRoleNames != null ? selectedRoleNames : "(undefined)"} does not exist`);
    return;
  }
  setError();
  setIsSubmitting(true);
  onSubmit(selectedRoles).then(() => {
    setselectedRoleNames();
    setIsSubmitting(false);
  });
};
const _loadRoles = (setPaginatedRoles) => {
  const getUnlimited = { page: 1, perPage: 0, query: "" };
  AuthzRolesDomain.loadRolesPaginated(getUnlimited).then(setPaginatedRoles);
};
const RolesSelector = ({
  assignedRolesIds,
  onSubmit,
  identifier = (role) => role.id,
  submitOnSelect = false
}) => {
  const [paginatedRoles, setPaginatedRoles] = useState();
  const [selectedRoleNames, setselectedRoleNames] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState();
  useEffect(() => _loadRoles(setPaginatedRoles), []);
  const onChange = (items) => {
    const newselectedRoleNameList = items;
    if (submitOnSelect) {
      _assignRole(
        newselectedRoleNameList,
        paginatedRoles.list,
        onSubmit,
        setselectedRoleNames,
        setIsSubmitting,
        setError
      );
    }
    setselectedRoleNames(items);
  };
  if (!paginatedRoles) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const _onSubmit = () => _assignRole(selectedRoleNames, paginatedRoles.list, onSubmit, setselectedRoleNames, setIsSubmitting, setError);
  const options = _options(paginatedRoles.list, assignedRolesIds, identifier);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FormElements, null, /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      onChange,
      optionRenderer: _renderRoleOption,
      options,
      placeholder: "Search for roles",
      multi: true,
      value: selectedRoleNames
    }
  ), !submitOnSelect && /* @__PURE__ */ React.createElement(
    SubmitButton,
    {
      bsStyle: "primary",
      onClick: _onSubmit,
      disabled: isSubmitting || !selectedRoleNames,
      title: "Assign Role",
      type: "button"
    },
    "Assign Role"
  )), /* @__PURE__ */ React.createElement(ErrorAlert, { runtimeError: true, onClose: setError }, error));
};
export default RolesSelector;
